export default __webpack_public_path__ + "static/media/greenTick.d9010584.webp";